import React from 'react';

import InputNumberPrefixed from './InputNumberPrefixed';

const InputCurrency = props => (
	<InputNumberPrefixed
		{...props}
		prefix="$"
		placeholder="0.00"
		multiplyByHundred={true}
		decimalPlaces={2}
	/>
);

export default React.memo(InputCurrency);
